/**
 * @author       julian@zumper.com (Julian Napolitan)
 * @copyright    Copyright (c) 2020, Zumper
 */

export const alias = (userId: string) => {
  if (userId) {
    if (window.dataLayer) {
      // @ts-expect-error
      window.dataLayer.push({ event: 'mixpanelAlias', mixpanelPayload: userId })
    } else {
      window.mixpanel?.alias?.(userId)
    }
  }
}
